<template>
  <div class="flex justify-center sm:justify-start mt-6 sm:mt-4 sm:-ml-1">
    <OLink
      v-if="author.social.website"
      pure
      class="w-8 h-8 rounded-full u-center mx-1"
      style="background: #fd9c17"
      :href="author.social.website"
      target="_blank"
    >
      <OIcon icon="article/world-globe-white" svg-class="w-4 h-4" />
    </OLink>
    <OLink
      v-if="author.social.twitter"
      pure
      class="w-8 h-8 rounded-full u-center mx-1 bg-[#333333]"
      :href="`https://twitter.com/${author.social.twitter}`"
      target="_blank"
    >
      <OIcon icon="article/twitter-white" svg-class="w-[15px] h-[15px] text-white" />
    </OLink>
    <OLink
      v-if="author.social.instagram"
      pure
      class="w-8 h-8 rounded-full u-center mx-1"
      style="background: linear-gradient(180.19deg, #7024c4 0.17%, #c21975 41.57%, #c74c4d 70.15%, #e09b3d 99.83%)"
      :href="`https://www.instagram.com/${author.social.instagram}`"
      target="_blank"
    >
      <OIcon icon="article/instagram-white" svg-class="w-4 h-4" />
    </OLink>
    <OLink
      v-if="author.social.facebook"
      pure
      class="w-8 h-8 rounded-full u-center mx-1"
      style="background: #4267b2"
      :href="`https://www.facebook.com/${author.social.facebook}`"
      target="_blank"
    >
      <OIcon icon="article/facebook-white" svg-class="w-4 h-4" />
    </OLink>

    <OLink
      v-if="author.social.linkedin"
      pure
      class="w-8 h-8 rounded-full u-center mx-1"
      style="background: #0077b5"
      :href="`https://www.linkedin.com/in/${author.social.linkedin}`"
      target="_blank"
    >
      <OIcon icon="article/linkedin-white" svg-class="w-4 h-4" />
    </OLink>
  </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OLink, OIcon } from '~/modules/common/components/ui';
export default defineComponent({
  components: { OLink, OIcon },
  props: {
    author: {
      type: Object,
      required: true,
    },
  },
  setup() {},
});
</script>
